module.exports = __webpack_public_path__ + "img/program.d0dddffd.png";